// Lógica de la caracterización (pasos "Bienestar y salud" y "Vida universitaria" del formulario v2), sin pantalla.
// Las preguntas llegan de api/v1.0/inscripcion/caracterizacion/preguntas (genéricas Car_P_ / Car_O_) ya
// ordenadas por paso y orden. Las reglas son las mismas que valida el backend (validar_caracterizacion).
// respuestas: { [codigo de la pregunta]: { opciones: [codigos de opción], texto: "" } }
import { consulta } from "../../../global/js/funciones";

// Pasos del formulario que arma la caracterización; "paso" es el valor de valorb en la genérica
export const PASOS_CARACTERIZACION = [
  { paso: 4, nombre: "Bienestar y salud" },
  { paso: 5, nombre: "Vida universitaria" },
];
export const PRIMER_PASO_CARACTERIZACION = 3; // índice en el formulario (después de "Mi carrera")
export const MAXIMO_TEXTO = 1000;

// Si el servicio falla, devuelve [] y el formulario sigue sin los pasos de caracterización
export function cargarPreguntasCaracterizacion() {
  return new Promise((resolve) => {
    consulta("api/v1.0/inscripcion/caracterizacion/preguntas", null, null, (error, estado, resp) => {
      resolve(!error && estado === 200 && Array.isArray(resp) ? resp : []);
    }, false);
  });
}

// Número de paso de la genérica que corresponde a un índice del formulario (null si no es de caracterización)
export function pasoCaracterizacion(indice) {
  const paso = PASOS_CARACTERIZACION[indice - PRIMER_PASO_CARACTERIZACION];
  return paso ? paso.paso : null;
}

// condicion: "Car_P_X=Car_O_Y" (eligió Y) o "Car_P_X!=Car_O_Y" (eligió algo distinto de Y). Vacía = siempre.
export function cumpleCondicion(condicion, respuestas) {
  if (!condicion) return true;
  const distinta = condicion.includes("!=");
  const [pregunta, opcion] = condicion.split(distinta ? "!=" : "=");
  const marcadas = (respuestas[pregunta] && respuestas[pregunta].opciones) || [];
  return distinta ? marcadas.some((o) => o !== opcion) : marcadas.includes(opcion);
}

// Deja solo las respuestas de las preguntas que aplican: si una respuesta cambia, se borran las que dependían de ella
export function limpiarOcultas(preguntas, respuestas) {
  const visibles = {};
  preguntas.forEach((p) => {
    if (respuestas[p.codigo] && cumpleCondicion(p.condicion, visibles)) visibles[p.codigo] = respuestas[p.codigo];
  });
  return visibles;
}

export function preguntasDelPaso(preguntas, respuestas, paso) {
  return preguntas.filter((p) => p.paso === paso && cumpleCondicion(p.condicion, respuestas));
}

// Opciones resultantes al hacer clic en una: la única reemplaza; la múltiple alterna y respeta las excluyentes
export function alternarOpcion(pregunta, actuales, codigo) {
  if (pregunta.tipo === "unica") return [codigo];
  if (actuales.includes(codigo)) return actuales.filter((c) => c !== codigo);
  const excluyentes = pregunta.opciones.filter((o) => o.excluyente).map((o) => o.codigo);
  if (excluyentes.includes(codigo)) return [codigo];
  return [...actuales.filter((c) => !excluyentes.includes(c)), codigo];
}

// [mensaje, codigo de la pregunta] de la primera pregunta del paso sin responder; ["", ""] si está completo
export function validarPasoCaracterizacion(preguntas, respuestas, paso) {
  for (const p of preguntasDelPaso(preguntas, respuestas, paso)) {
    const r = respuestas[p.codigo] || {};
    const texto = String(r.texto || "").trim();
    if (p.tipo === "texto") {
      if (p.obligatoria && !texto) return ["Responde las preguntas obligatorias (*).", p.codigo];
      if (texto.length > MAXIMO_TEXTO) return [`La respuesta no puede superar ${MAXIMO_TEXTO} caracteres.`, p.codigo];
    } else if (p.obligatoria && !(r.opciones || []).length) {
      return ["Responde las preguntas obligatorias (*).", p.codigo];
    }
  }
  return ["", ""];
}

// Lo que se envía al backend (campo "caracterizacion"): solo preguntas que aplican y con respuesta
export function armarCaracterizacion(preguntas, respuestas) {
  return preguntas
    .map((p) => {
      const r = respuestas[p.codigo] || {};
      return { pregunta: p.codigo, opciones: r.opciones || [], texto: String(r.texto || "").trim() };
    })
    .filter((r) => r.opciones.length || r.texto);
}
